import { createQueryKeys } from '@lukemorales/query-key-factory';
import { type MaybeRef, unref } from 'vue';
import {
  relatiesGetBy,
  relatiesGetRelationByRelatienummer,
} from '@services/crm-public/orval-api/relaties-api/relaties-api';

export const relatieQueries = createQueryKeys('relatie', {
  get: (relatienummer: MaybeRef<number>) => ({
    queryKey: [relatienummer],
    queryFn: () => relatiesGetRelationByRelatienummer(unref(relatienummer)),
  }),
  search: (params: {
    naam?: MaybeRef<string | undefined>;
    naamNummer?: MaybeRef<string | undefined>;
    kvknummer?: MaybeRef<string | undefined>;
    polisnummer?: MaybeRef<string | undefined>;
    limit?: MaybeRef<number | undefined>;
  }) => ({
    queryKey: ['relatie', params],
    queryFn: () =>
      relatiesGetBy({
        Naam: unref(params.naam),
        NaamNummer: unref(params.naamNummer),
        Kvknummer: unref(params.kvknummer),
        Polisnummer: unref(params.polisnummer),
        Limit: unref(params.limit),
      }),
  }),
});
